let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f3edP")).then(() => parcelRequire('3XNgZ'));